import React from 'react'

import clsx from 'clsx'

import classes from './DialogContent.module.scss'

/** @type {import("./types").default} */
const DialogContent = ({ children, className, dividers }) => {
  return (
    <div className={clsx('DialogContent', classes.root, { [classes.dividers]: dividers }, className)}>{children}</div>
  )
}

export default DialogContent
